import React from 'react'
import Card from 'react-bootstrap/Card'
import { Review as ReviewType } from 'types'
import { getTextShort } from '@helpers/helper.rendering'
// @ts-ignore 
import Avatar from './assets/avatar_default.webp'
// @ts-ignore 
import GLogo from './assets/google_G.webp' 

interface PropsType {
    skeleton?: boolean,
    review?: ReviewType
}

const Review = (props: PropsType) => {

    const {review, skeleton} = props;

    return (
        <a href={review?.link ? review?.link : ""} target="_blank"
            id="review-wrapper" className={"link d-flex" + (review?.link ? " cursor-pointer" : "") + (skeleton ? " skeleton-card" : "")}>
            <Card className="text-center review-card rc">
                <Card.Body className={"p-4" + (skeleton ? " skeleton-body" : "")}>
                    <div className="d-flex flex-column align-items-center top-review-content">
                        <img src={review?.image ? review?.image : Avatar} alt={review?.title ? review?.title : "Avatar"} className="avatar"/>
                        <div className="stars-container mt-4">
                            { !skeleton ? review?.starts?.map(() => <i className="icon-favoritos-star-solid"></i>) : null }
                        </div>
                    </div>
                    <Card.Text className={"mt-4" + (skeleton ? " skeleton-text" : "")}>
                        { !skeleton ? (review?.paragraph ? getTextShort(review?.paragraph, 130) : null) : null }
                    </Card.Text>
                    <Card.Title className={"mt-4" + (skeleton ? " skeleton-title" : "")}>
                        { !skeleton ? (review?.title ? review?.title : null) : null }
                    </Card.Title>
                    <div className="g-signature d-flex justify-content-center align-items-center mt-4">
                        <img src={GLogo} alt="Google Reviews" className="g-logo"/>
                        <span className="signature-text ms-2">Google Reviews</span>
                    </div>
                </Card.Body>
            </Card>
        </a>
    )
}

export default Review